module.exports = "/images/gotham-16.jpg";